var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M20.247 13.036a2.2 2.2 0 0 1-.904.92L7.69 20.242a2.153 2.153 0 0 1-2.937-.92 2.25 2.25 0 0 1-.253-1.036V5.714c0-1.223.973-2.214 2.173-2.214.354 0 .704.088 1.017.257l11.653 6.286c1.06.572 1.466 1.912.904 2.993M6.5 18.5l12-6.5-12-6.5z"
})));
export default SvgGemPlay;